import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider";
import React from "react";
import "./App.scss";
import { AppRoutes } from "./AppRoutes";
import { useCoreFacade } from "./modules/core/facades/Core.facade";
import { ApiService } from "./modules/core/services/Api.service";

function App() {

  // Some comments. Delete it

  const coreFacade = useCoreFacade();

  coreFacade.setupApplication();

  return (
    <ApolloProvider client={ApiService.getApolloClient()}>
      <div>
        <AppRoutes />
      </div>
    </ApolloProvider>
  );
}

export default App;
